//#region IMPORTS
import { useCallback, useEffect } from "react";
import { clearBackOrder } from "../backorder/backOrderSlice";
import { useAppDispatch } from "../../store/configureStore";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
//#endregion

export default function CheckoutConfirm() {
  //#region SETUP
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  //#endregion

  //#region LOGIC
  const resetBackOrderItems = useCallback(async () => {
    try {
      dispatch(clearBackOrder());
      history.push("/");
    } catch (error) {
      toast.warning(`${error}`);
    }
  }, [dispatch, history]);

  useEffect(() => {
    const timer = setTimeout(() => {
      resetBackOrderItems();
    }, 5000);
    return () => clearTimeout(timer);
  }, [resetBackOrderItems]);
  //#endregion

  //#region RENDER
  return (
    <div
      onClick={resetBackOrderItems}
      className="fixed inset-0 z-[2001] flex items-center justify-center bg-black/50"
    >
      <div className="flex flex-col items-center justify-center text-center p-4 bg-[#191915] text-white w-[300px] h-[250px] text-base lg:w-[500px] lg:text-lg">
        <h1>Rituals...</h1>
        <p>
          {t("rituals.thanksForYourOrder.")}
          <br />
          {t("rituals.theOrderIsNowPendingApprovalAtHeadquarters.")}
        </p>
      </div>
    </div>
  );
  //#endregion
}
